import { Image } from 'antd'
import cls from 'classnames'
import React, { useEffect, useRef } from 'react'

import { UserHoverCard } from '@/components'
import { PostType } from '@/generated/graphql'
import { routes } from '@/routes'

import { PostEditor } from '../post/post-editor'
import s from './game-hub.module.less'

interface GameCard {
  id: string
  title: string
  description: string
  rating: string
  users: string
  imageClass: string
  image: string
  slogan?: string
  link: string
  featured?: boolean
}

const GameHub: React.FC = () => {
  const cardsRef = useRef<HTMLDivElement>(null)
  const parallaxRef = useRef<HTMLDivElement>(null)

  const games: GameCard[] = [
    {
      id: 'game-3',
      title: '我是渣渣辉，快来帮我砍一刀，事成之后封你为海军陆战队总司令',
      description: '一刀 999， 点9',
      rating: '999.9',
      users: 'liaochenliang@agora.io',
      imageClass: 'game-3',
      icon: 'https://agora-web-cdn.oss-cn-beijing.aliyuncs.com/tale/ai-game/icons/zhazhahui.jpeg',
      image: 'https://agora-web-cdn.oss-cn-beijing.aliyuncs.com/tale/ai-game/渣渣辉.jpg',
      link: 'https://ifile.wrapper.gz3.agoralab.co/game/trump',
      featured: true,
    },
    {
      id: 'game-1',
      title: '临安浮生记',
      slogan: '“商贾逐利如水走下，浮生若梦似云卷舒”',
      description: `公元1140年，岳飞北伐抗金之际，你作为一名初到临安的商人，带着年幼的妹妹逃难至此。不幸妹妹被人贩子带走，你必须在36旬（12个月）内通过倒买倒卖积累十万文财富，赎回妹妹并成为临安城首富。`,
      rating: '5.0',
      users: 'lixinwei@agora.io',
      imageClass: 'game-1',
      icon: 'https://agora-web-cdn.oss-cn-beijing.aliyuncs.com/tale/ai-game/icons/hangzhou.png',
      image: 'https://agora-web-cdn.oss-cn-beijing.aliyuncs.com/tale/ai-game/临安浮生记.png',
      link: 'https://www.modelscope.cn/studios/xinweili93/LinAn',
    },
    {
      id: 'game-2',
      title: 'Agora Rush',
      description: '冲就完事了！',
      rating: '5.0',
      users: 'tangqiubo@agora.io',
      imageClass: 'game-2',
      icon: 'https://agora-web-cdn.oss-cn-beijing.aliyuncs.com/tale/ai-game/icons/race-car.png',
      image: 'https://agora-web-cdn.oss-cn-beijing.aliyuncs.com/tale/ai-game/声冲.png',
      link: 'http://112.13.168.209:30000',
    },
  ]

  const [visible, setVisible] = React.useState(false)
  useEffect(() => {
    // 卡片动画观察器
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px',
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          ;(entry.target as HTMLElement).style.opacity = '1'
          ;(entry.target as HTMLElement).style.transform = 'translateY(0)'
        }
      })
    }, observerOptions)

    const cards = document.querySelectorAll(`.${s['showcase-card']}`)
    cards.forEach((card, index) => {
      ;(card as HTMLElement).style.opacity = '0'
      ;(card as HTMLElement).style.transform = 'translateY(50px)'
      ;(card as HTMLElement).style.transition = `opacity 0.6s ease ${index * 0.1}s, transform 0.6s ease ${index * 0.1}s`
      observer.observe(card)
    })

    // 视差滚动效果
    const handleScroll = () => {
      const scrolled = window.pageYOffset
      if (parallaxRef.current) {
        const speed = scrolled * 0.5
        parallaxRef.current.style.transform = `translateY(${speed}px)`
      }
    }

    window.addEventListener('scroll', handleScroll)

    return () => {
      observer.disconnect()
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  const postEditor = <PostEditor visible={visible} onClose={() => setVisible(false)} postType={PostType.General} />

  return (
    <div className={s['game-hub']}>
      {/* 主要内容 */}
      <main className={s['main-content']}>
        {/* 游戏展示区域 */}
        <section id='games' className={s['showcase-section']}>
          <div className={s['section-header']}>
            <h2 className={s['section-title']}>精选游戏</h2>
            <p className={s['section-subtitle']}>体验最新潮的游戏世界</p>
          </div>

          <div className={s['showcase-grid']} ref={cardsRef}>
            {games.map((game) => (
              <div key={game.id} className={cls(s['showcase-card'], game.featured && s['featured'])}>
                <div className={s['card-image']}>
                  <div className={cls(s['placeholder-image'], s[game.imageClass])}>
                    <Image width={'100%'} src={game.image} preview={false} alt={game.title} />
                  </div>
                  <div className={s['card-overlay']}>
                    <button
                      type='button'
                      className={s['play-button']}
                      onClick={() => window.open(game.link, '_blank', 'noopener,noreferrer')}
                    >
                      立即游玩
                    </button>
                  </div>
                </div>
                <div className={s['card-content']}>
                  <div className={s['card-title-container']}>
                    <h3 className={s['card-title']}>{game.title}</h3>
                    {game.slogan && <p className={s['card-description']}>{game.slogan}</p>}
                  </div>

                  <p className={s['card-description']}>{game.description}</p>
                  <div className={s['card-stats']}>
                    <span>⭐ {game.rating}</span>
                    <UserHoverCard email={game.users}>
                      <span
                        className={cls(s['stat-item'])}
                        onClick={(e) => {
                          e.stopPropagation()
                          window.open(routes.users.page(game.users), '_blank', 'noopener,noreferrer')
                        }}
                      >
                        👤 <span className={s['user-name']}>{game.users}</span>
                      </span>
                    </UserHoverCard>
                    <span className={cls(s['stat-item'])} onClick={() => setVisible(true)}>
                      👀 <span className={s['share-button']}>分享战绩</span>
                    </span>
                    {postEditor}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>
      </main>
    </div>
  )
}

export default GameHub
